import * as types from './Types.js';

export function findCargosPaginado(filtro) {
  return ({ fetch }) => ({
    type: types.LIST_CARGOS,
    payload: {
      promise: fetch(`/api/cargos?${filtro}`)
    }
  });
}

export function findFaixas(filtro) {
  return ({ fetch }) => ({
    type: types.LIST_FAIXAS,
    payload: {
      promise: fetch(`/api/cargos/faixas?${filtro}`)
    }
  });
}

export function findCargosNaoPaginado(filtro) {
  return ({ fetch }) => ({
    type: types.FILTRO_CARGOS,
    payload: {
      promise: fetch(`/api/cargos/cargos?${filtro}`)
    }
  });
}

export function findQuadrosSalarial(filtro) {
  return ({ fetch }) => ({
    type: types.FILTRO_QUADROS,
    payload: {
      promise: fetch(`/api/cargos/quadros?${filtro}`)
    }
  });
}

export function findGruposOcupacional(filtro) {
  return ({ fetch }) => ({
    type: types.FILTRO_GRUPOS,
    payload: {
      promise: fetch(`/api/cargos/grupos?${filtro}`)
    }
  });
}

export function findNiveis(filtro) {
  return ({ fetch }) => ({
    type: types.FILTRO_NIVEIS,
    payload: {
      promise: fetch(`/api/cargos/niveis?${filtro}`)
    }
  });
}

export function findFuncoesGratificadasPaginado(filtro) {
  return ({ fetch }) => ({
    type: types.LIST_FUNCOES_GRATIFICADAS,
    payload: {
      promise: fetch(`/api/funcao-gratificada?${filtro}`)
    }
  });
}

export function loadCargos(filtro) {
  return ({ fetch }) => ({
    type: types.LIST_CARGOS_OXY,
    payload: {
      promise: fetch(`/api/cargos/busca-cargos?${filtro}`)
    }
  });
}

export function findTipoCargoSelect(filtro) {
  return ({ fetch }) => ({
    type: types.FILTRO_CARGOS,
    payload: {
      promise: fetch(`/api/cargos/tipo-cargo?${filtro}`)
    }
  });
}

export function findVigenciaMatrizSalarialSelect(filtro) {
  return ({ fetch }) => ({
    type: types.LIST_MATRIZ_VIGENTE,
    payload: {
      promise: fetch(`/api/cargos/matrizes-vigencia?matriz=${filtro}`)
    }
  });
}

export function findMatrizes(filtro) {
  return ({ fetch }) => ({
    type: types.LIST_MATRIZES_SUCCESS,
    payload: {
      promise: fetch(`/api/cargos/matrizes?${filtro}`)
    }
  });
}

export function getMatrizVigente(filtro) {
  return ({ fetch }) => ({
    type: types.LIST_MATRIZ,
    payload: {
      promise: fetch(`/api/cargos/matriz-vigente?${filtro}`)
    }
  });
}

export function loadCargosReduzido() {
  return ({ fetch }) => ({
    type: types.LIST_CARGOS_REDUZIDO_OXY,
    payload: {
      promise: fetch('/api/cargos/dados-cargos')
    }
  });
}
